import '../../Div/index.js';
import '../../Image/index.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../../Div/Div.js';
import { Image } from '../../Image/Image.js';
const BlockEmbeddedAsset = ({
  defaultSpacingTop
} = {}) => function embeddedAsset(node) {
  return /*#__PURE__*/jsx(Div, {
    spacingTop: defaultSpacingTop,
    children: /*#__PURE__*/jsx(Image, {
      loading: "lazy",
      maxWidth: "100%",
      alt: node?.data?.target?.fields?.title || '',
      src: node?.data?.target?.fields?.file?.url || ''
    })
  });
};
export { BlockEmbeddedAsset };
//# sourceMappingURL=BlockEmbeddedAsset.js.map
